/* eslint-disable no-useless-escape */
/* eslint-disable react/jsx-props-no-spreading */
import { FC, useRef } from 'react';

import { IconBlockInfo } from 'app/components/ui/icon-block';
import { ContentDetails } from 'app/components/content-details';
import { ScrollableTrayContainer } from 'app/components/ui/scrollable-tray-container';
import { Container } from 'app/components/content-block/container';
import { Image } from 'app/components/image';
import { useMobileHeader } from 'app/components/header/hooks/use-mobile-header';
import { Header } from 'app/components/header';
import { useMobileScroll } from 'app/components/content-block/mobile-content-block/use-mobile-scroll';

export interface MobileContentBlockProps {
  title: string;
  upperSubtitle?: string;
  lowerSubtitle?: string;
  description?: string | undefined;
  richDescription?: string;
  showRichDescription?: boolean;
  descriptionTitleText?: string;
  imgUrl?: string;
  imgAltText?: string;
  haveClaimedText?: string;
  descriptionViewDetailText: string;
  iconBlocks?: Array<IconBlockInfo>;
  participantsCount?: string;
  hostedBy?: string;
  onBackClick: () => void;
}

export const MobileContentBlock: FC<MobileContentBlockProps> = ({
  title,
  imgAltText,
  upperSubtitle,
  lowerSubtitle,
  description,
  richDescription,
  showRichDescription,
  imgUrl,
  iconBlocks,
  descriptionTitleText,
  descriptionViewDetailText,
  participantsCount,
  haveClaimedText,
  hostedBy,
  onBackClick,
  ...rest
}: MobileContentBlockProps) => {
  const backArrowMobileHeaderRef = useRef<HTMLDivElement>() as React.MutableRefObject<HTMLDivElement>;
  const containerRef = useRef<HTMLDivElement>() as React.MutableRefObject<HTMLDivElement>;
  const scrollableContainerRef = useRef<HTMLElement>() as React.MutableRefObject<HTMLElement>;
  const formattedRichDescription = richDescription?.replace('<span style=\"font-size:12px\">⬇</span>', '<span style=\"font-size:24px\">⬇</span>');

  useMobileHeader({ backArrowMobileHeaderRef, containerRef, scrollableContainerRef });

  const { imageRef, initialImageHeight } = useMobileScroll({ containerRef });

  return (
    <Container data-testid="mobile-content-block" {...rest} className="relative overflow-auto">
      <Header onBackClick={onBackClick} backArrowMobileHeaderRef={backArrowMobileHeaderRef} />
      <Image
        src={imgUrl}
        alt={imgAltText ?? title}
        imageRef={imageRef}
        className="absolute top-0 left-0 w-screen h-auto object-cover"
      />
      <div
        ref={containerRef}
        className="flex w-full h-screen overflow-scroll overscroll-bounce [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] [scroll-behavior:smooth] [-webkit-overflow-scrolling:touch]"
        style={{
           WebkitOverflowScrolling: 'touch',
           overscrollBehavior: 'contain',
         }}
      >
        <ScrollableTrayContainer marginTop={initialImageHeight} scrollableContainerRef={scrollableContainerRef as React.MutableRefObject<HTMLDivElement>}>
          <ContentDetails
            title={title}
            upperSubtitle={upperSubtitle}
            lowerSubtitle={lowerSubtitle}
            description={description}
            richDescription={formattedRichDescription}
            showRichDescription={showRichDescription}
            iconBlocks={iconBlocks}
            descriptionTitleText={descriptionTitleText}
            descriptionViewDetailText={descriptionViewDetailText}
            participantsCount={participantsCount}
            haveClaimedText={haveClaimedText}
            hostedBy={hostedBy}
          />
        </ScrollableTrayContainer>
      </div>
    </Container>
  );
};
